import UnitModule from './unit.module';
import sort from 'fast-sort';
import {createUnit, loadUnits, copyUnit} from '@/modules/ProjectModule/modules/UnitModule/api/unit.api';

function initialState() {
    return {
        units: [],
    }
}

export default {
    namespaced: true,
    state:      initialState,
    getters:    {
        units:                (state) => state.units,
        unitsForAutocomplete: (state) => state.units.map(({ id, designation }) => {
            return { name: designation, id };
        }),
    },
    actions:    {
        async init({ dispatch }) {
            await dispatch('reset');
            return dispatch('loadUnits');
        },
        async loadUnits({ commit, rootGetters }) {
            const projectId = rootGetters['projects/project/projectId'];
            return loadUnits(projectId).then((data) => commit('SET_UNITS', data));
        },
        async createUnit({ commit, getters, rootGetters }, data) {
            const projectId = rootGetters['projects/project/projectId'];
            return createUnit({ ...data, projectId }).then((data) => {
                commit('ADD_UNIT', data);
                return data;
            })
        },
        async copyUnit({ getters, commit }, data) {
            return copyUnit(data).then((data) => {
                commit('ADD_UNIT', data);
                return data;
            });
        },
        reset: ({ commit }) => commit('RESET'),
    },
    mutations:  {
        SET_UNITS: (state, data) => state.units = sort(data).asc('designation'),
        ADD_UNIT:  (state, data) => state.units.push(data),
        RESET:     (state) => {
            const s = initialState();
            Object.keys(s).forEach(key => state[key] = s[key]);
        }
    },
    modules:    {
        unit: UnitModule,
    }
}
